import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { AddSonPopupComponent } from '../dialogs/add-son-popup/add-son-popup.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmPopupComponent } from '../dialogs/confirm-popup/confirm-popup.component';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.sass']
})
export class WelcomeComponent implements OnInit {

  showSpinner: boolean = false;

  students: any[] = [];
  relationships: any;
  reportages: any;

  relationshipIdList: any = {}

  showNoStudentMessage: boolean = false;
  showNoReportageMessage: boolean = false;

  constructor(
    public dataService: DataService,
    public router: Router,
    private translate: TranslateService,
    private snackbar: MatSnackBar,
    private _md: MatDialog,
  ) { }

  ngOnInit(): void {

    // TODO Make sure if spinner works correctly with multiple students
    this.showSpinner = true;
    this.dataService.getRelationships('', 'photo').subscribe(relationships => {

      this.relationships = relationships;

      // This is used to create dynamic links to each of the student's pages
      this.relationships.forEach(element => {

        this.relationshipIdList[element.student._flat_path[1]] = element.id;

      });

      if ((this.relationships).length == 0) { this.showSpinner = false; this.showNoStudentMessage = true; }

      this.relationships.forEach(relationship => {
        this.showSpinner = true
        this.dataService.getStudent({ 'relationship_id': relationship.id }).subscribe(student => {
          this.students.push(student)


          let unordered_students = this.students;

          let ordered_students = unordered_students.sort((a, b) => {
            if (a.name < b.name) { return -1; }
            if (a.name > b.name) { return 1; }
            return 0;
          })

          this.students = ordered_students;


          this.showSpinner = false;
        })
      });


      // this.showSpinner = false;
    });

    this.dataService.getRelatedReportages('','photo').subscribe(reportages => {

      let unordered_rels = []

      for (let reportage in reportages) {
        unordered_rels.push(reportages[reportage]);
      }

      let ordered_rels = unordered_rels.sort((a, b) => {
        if (a.name < b.name) { return -1; }
        if (a.name > b.name) { return 1; }
        return 0;
      })

      this.reportages = ordered_rels;

      if ((this.reportages).length == 0) { this.showSpinner = false; this.showNoReportageMessage = true; }
    });


  }

  async addSon() {
    let res = await this._md.open(AddSonPopupComponent, { autoFocus: false, disableClose: true, minWidth: '350px' }).afterClosed().toPromise()

    console.log(res)

    if(res) {
      // this.snackbar.openFromComponent(CustomPopupComponent, { data: this.translate.instant('alerts.add_son_success'), duration: 10000, panelClass: "success-snackbar" }).afterDismissed().subscribe(resp => {
      //   window.location.reload()
      // })
    this._md.open(ConfirmPopupComponent, { autoFocus: false, data: {message: this.translate.instant('alerts.add_son_success')}, disableClose: true, width: '350px' }).afterClosed().subscribe(resp => {
        window.location.reload()
      })

    }
  }


  redirectTo(uri: string) {

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([uri]));
  }

}
